export const getCurrentESTDateTimeFormatted = () => {
  const now = new Date();

  const formatter = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  return formatter.format(now); // e.g., "06/10/2025, 14:32:10"
};

export const getDocumentId = (doc: any) => String(doc?.DocumentId ?? doc?.documentId ?? '');

export const getSelectedReturnIdValue = (value: any): string => {
  if (!value) return '';
  if (typeof value === 'string') return value;

  return String(
    value.SelectedReturnId ??
      value.SelectedReturnID ??
      value.InternalK1SelectedReturnId ??
      value.ReturnId ??
      value.returnId ??
      value.value ??
      '',
  );
};

export const getApiSelectedReturnId = (doc: any): string =>
  getSelectedReturnIdValue(
    doc?.InternalK1SelectedReturnId ??
      doc?.SelectedReturnId ??
      doc?.SelectedReturnID ??
      doc?.SelectedReturn ??
      doc?.selectedReturnId,
  );

export const normalizeSelectedParents = (selectedParents: any): Record<string, string> => {
  if (!selectedParents) return {};

  if (Array.isArray(selectedParents)) {
    return selectedParents.reduce<Record<string, string>>((acc, item) => {
      const docId = String(item?.DocumentId ?? item?.documentId ?? item?.SourceDocumentId ?? '');
      const selectedReturnId = getSelectedReturnIdValue(item);
      if (docId && selectedReturnId) acc[docId] = selectedReturnId;
      return acc;
    }, {});
  }

  if (typeof selectedParents === 'object') {
    return Object.entries(selectedParents).reduce<Record<string, string>>((acc, [docId, value]) => {
      const selectedReturnId = getSelectedReturnIdValue(value);
      if (docId && selectedReturnId) acc[String(docId)] = selectedReturnId;
      return acc;
    }, {});
  }

  return {};
};
